import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/person-search")({
  beforeLoad: () => {
    throw redirect({ to: "/search", search: {"tab":"people"}, replace: true });
  },
});
